import React, { useEffect, useState } from 'react';
import { useAssessment } from '@/contexts/AssessmentContext';
import { calculateScores } from '@/utils/scoringUtils';
import AssessmentFormStep from './assessment/AssessmentFormStep';
import AssessmentResultsStep from './assessment/AssessmentResultsStep';
import { supabase } from '@/lib/supabase';

import { Loader2 } from 'lucide-react';

const AssessmentSteps = () => {
  const { 
    isLoading,
    currentStep, 
    setCurrentStep, 
    weights,
    opportunities,
    setScoredOpportunities,
    scoredOpportunities,
    scoringParams,
    recalculateScores,
  } = useAssessment();
  
  const handleNext = () => {
    console.log('handleNext', currentStep);
    if (currentStep === 1) {
      // Always recalculate scores with current weights (which might be temporary changes)
      const scoredOpps = calculateScores(opportunities, weights, scoringParams);
      setScoredOpportunities(scoredOpps);
      
      // Only proceed to next step if we have valid scores
      if (scoredOpps && scoredOpps.length > 0) {
        // Scroll to top of page before changing step
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
        
        setCurrentStep(currentStep + 1);
        
        // Log that we're using temporary weights without saving
        console.log('Using temporary weights for opportunity scoring:', weights);
      } else {
        console.warn('Unable to proceed - no opportunities were scored');
      }
    }
  };

  const handleBack = () => {
    // Scroll to top of page before changing step
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    
    setCurrentStep(1);
  };
  
  // Effect to handle empty scoredOpportunities on initial load by simulating back button click
  useEffect(() => {
    console.log('AssessmentSteps effect - currentStep:', currentStep, 'scoredOpportunities.length:', scoredOpportunities?.length);
    
    // If we're on step 2 (results) but have empty opportunities, simulate back button click
    if (currentStep === 2 && (!scoredOpportunities || scoredOpportunities.length === 0)) {
      console.log('Detected empty opportunities on results page, simulating back button');
      handleBack();
    }
  }, [currentStep, scoredOpportunities]);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-96">
        <Loader2 className="h-8 w-8 animate-spin text-gray-500" />
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8 max-w-[1400px] space-y-8">
      {currentStep === 1 && (
        <AssessmentFormStep onNext={handleNext} />
      )}

      {currentStep === 2 && (
        <AssessmentResultsStep onBack={handleBack} scoredOpportunities={scoredOpportunities} />
      )}
    </div>
  );
};

export default AssessmentSteps;